<template>
    <div class="vue-youtube-wrapper">
        <template v-if="hasYoutubeVideoId">
            <div class="inner">
                <template v-if="showThumbnail === true">
                    <slot></slot>
                </template>

                <youtube :video-id="youtubeVideoId" ref="youtube"></youtube>
                <img src="/themes/custom/ef2_custom/img/video-fallback-nl.jpg" alt="" class="video-fallback">

                <button class="play-button" @click="handlePlayClick" :class="showThumbnail ? '' : 'hide'">
                    Play
                </button>
            </div>
        </template>
        <template v-if="!hasYoutubeVideoId && hasVimeoUrl">
            <div class="inner">
                <iframe class="vimeo-frame" :src="vimeoUrl" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    name: "YoutubeWrapper",

    props: ['iframeSrc'],

    data() {
        return {
            showThumbnail: true
        }
    },

    computed: {
        youtubeVideoId() {
            let url = this.iframeSrc.replace(/(>|<)/gi, '').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);

            if (! lodash.isNil(url[2])) {
                return url[2].split(/[^0-9a-z_\-]/i)[0];
            }

            return '';
        },

        vimeoUrl() {
            let vimeoRegex = /(?:https?\:\/\/)?(?:www\.)?(?:vimeo\.com\/)([0-9]+)/;

            if (!vimeoRegex.test(this.iframeSrc)) {
                return;
            }

            return this.iframeSrc.replace('https://vimeo.com/', 'https://player.vimeo.com/video/')
        },

        hasVimeoUrl() {
            return !lodash.isNil(this.vimeoUrl);
        },

        hasYoutubeVideoId() {
            return ! _.isEmpty(this.youtubeVideoId);
        },

        player() {
            return this.$refs.youtube.player
        }
    },

    methods: {
        handlePlayClick() {
            this.showThumbnail = false;

            this.player.playVideo();
        }
    }
}
</script>